/**
 * 公共函數
 */

import _ from 'lodash';
import { Notification, Loading } from 'element-ui';
import accounting from 'accounting';
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';
import xxtea from 'xxtea-node';
import appConfig from '../app.config';

/* eslint-disable import/prefer-default-export */

/**
 * 使用element-ui通知组件显示api相应的errors信息
 * @param error
 */
export function showErrorMessage(error) {
  if (error.response) {
    const { errors } = error.response.data.errors;
    _.forEach(errors, (msgs) => {
      _.forEach(msgs, (message) => {
        setTimeout(() => {
          Notification({
            title: error.response.data.message,
            type: 'error',
            message,
          });
        }, 0);
      });
    });
  }
}

export function Probability(...$args) {
  const probas = [];
  const functions = [];
  const args = _.isArray($args[0]) ? $args[0] : $args;

  args.push({
    p: 0,
    f() {},
  });

  for (let i = 0, l = args.length, sum = 0; i < l; i++) {
    let p = Math.abs(parseFloat(args[i].p));
    const { f } = args[i];

    if (_.isNaN(p) || typeof f !== 'function') {
      throw new TypeError(`Probability.js: Invalid probability object in argument ${i} .`);
    }

    if (/%/.test(args[i].p)) {
      p /= 100.0;
    }

    sum += p;

    if (sum > 1.0) {
      throw new TypeError(`Probability.js: Probability exceeds "1.0"
        (=100%) in argument ${i}: p="${p}" (=${p * 100}%), sum="${sum}" (=${sum * 100}%).`);
    }

    probas[i] = sum;
    functions[i] = f;
  }

  return function probabilitilized() {
    const random = Math.random();
    let i = 0;
    for (let l = probas.length - 1; i < l && random >= probas[i]; i++) {
      /* intentionally left empty */
    }
    return functions[i].apply(this, ...args);
  };
}

export function weightCeiling(weight, base) {
  if (base >= 0) return weight;
  if (weight <= 0 || weight <= base) {
    return base;
  }
  const pow = 10 ** 4;
  let w = Math.floor(weight * pow);
  const b = Math.floor(base * pow);
  const mod = w % b;
  w = (w - mod) + (mod > 0 ? base : 0);

  return w / pow;
}

export function getLocale() {
  const navigatorLanguage = window.navigator.language.replace('-', '_');
  const supports = ['zh_HK', 'zh_CN', 'zh_TW', 'zh_MO', 'en', 'ja', 'de', 'fr', 'ko', 'th'];
  if (~supports.indexOf(navigatorLanguage)) {
    return navigatorLanguage;
  }
  if (navigatorLanguage.startsWith('en')) {
    return 'en';
  }
  if (navigatorLanguage.startsWith('zh_TW')) {
    return 'zh_HK';
  }
  if (navigatorLanguage.startsWith('de')) {
    return 'de';
  }
  if (navigatorLanguage.startsWith('fr')) {
    return 'fr';
  }
  return 'zh_HK';
}

export function formatMoney(number, currency) {
  let symbol;
  let precision = 2;
  let format = '%s%v';
  if (typeof currency === 'string') {
    // eslint-disable-next-line
    currency = currency.toUpperCase();
  }
  switch (currency) {
    case 'EUR':
      symbol = '€';
      break;
    case 'GBP':
      symbol = '£';
      break;
    case 'JPY':
      symbol = '¥';
      precision = 0;
      format = '%s%v円';
      break;
    case 'CNY':
      symbol = 'RMB¥';
      break;
    case 'HKD':
      symbol = 'HK$';
      break;
    case 'USD':
      symbol = 'US$';
      break;
    case 'KRW':
      symbol = '₩';
      precision = 0;
      break;
    case 'TWD':
      symbol = 'NT$';
      precision = 0;
      break;
    case 'THB':
      symbol = '฿';
      break;
    case 'SGD':
      symbol = 'S$';
      break;
    case 'MYR':
      symbol = 'RM';
      precision = 0;
      break;
    case 'IDR':
      symbol = 'Rp';
      precision = 0;
      break;
    case 'PHP':
      symbol = '₱';
      break;
    // case 'CHF':
    //   break;
    case 'TRY':
      symbol = '₺';
      break;
    case 'CAD':
      symbol = 'Can$';
      break;
    case 'MXN':
      symbol = 'Mex$';
      break;
    // case 'AED':
    //   symbol = 'د.إ';
    //   break;
    // case 'SAR':
    //   symbol = 'ر.س';
    //   break;
    case 'INR':
      symbol = '₹';
      precision = 0;
      break;
    case 'NZD':
      symbol = 'NZ$';
      precision = 0;
      break;
    case 'AUD':
      symbol = 'AUD$';
      break;
    case 'RUB':
      symbol = '₽';
      break;
    default:
      symbol = currency;
      break;
  }
  return accounting.formatMoney(number, symbol, precision, ',', '.', format);
}

export function phoneValidate(number, countryCode, type) {
  const phoneNumber = parsePhoneNumberFromString(number, countryCode);
  if (!phoneNumber) {
    return false;
  }
  if (type) {
    return phoneNumber.isValid() && phoneNumber.getType().toLowerCase() === type.toLowerCase();
  }
  return phoneNumber.isValid();
}

export function getDefaultEnvByIsoCode2(isoCode) {
  /* eslint-disable spaced-comment, no-multi-spaces */
  let currency;
  let language;
  switch (isoCode) {
    case 'CN':
      currency = 'CNY';
      language = 'zh_CN';
      break;
    case 'JP':
      currency = 'JPY';
      language = 'ja';
      break;
    case 'US':
    case 'PR':  //Puerto Rico
    case 'MP':  //Northern Mariana Islands
    case 'VI':  //United States Virgin Islands
    case 'AS':  //American Samoa
    case 'GU':  //Guam
    case 'SV':  //El Salvador
    case 'PA':  //Panama
    case 'EC':  //Ecuado
    case 'TL':  //Timor-Leste (East Timor)
    case 'MH':  //Marshall islands
    case 'FM':  //Federated States of Micronesia
    case 'PW':  //Palau
      currency = 'USD';
      language = 'en';
      break;
    case 'GB':
      currency = 'GBP';
      language = 'en';
      break;
    // 欧盟国家
    case 'AT':  //Austria
    case 'BE':  //Belgium
    case 'BG':  //Bulgaria
    case 'CYP':  //Cyprus
    case 'HR':  //Croatia
    case 'HT':  //Haiti
    case 'CZ':  //CzechRepublic
    case 'DK':  //Denmark
    case 'EE':  //Estonia
    case 'FI':  //Finland
    case 'GR':  //Greece
    case 'HU':  //Hungary
    case 'IE':  //Ireland
    case 'IT':  //Italy
    case 'LV':  //Latvia
    case 'LT':  //Lithuania
    case 'LU':  //Luxembourg
    case 'MT':  //Malta
    case 'NL':  //Netherlands
    case 'PL':  //Poland
    case 'PT':  //Portugal
    case 'RO':  //Romania
    case 'SK':  //Slovakia
    case 'SI':  //Slovenia
    case 'ES':  //Spain
    case 'SE':  //Sweden
      currency = 'EUR';
      language = 'en';
      break;
    case 'DE':  //Germany
      currency = 'EUR';
      language = 'de';
      break;
    case 'FR':  //France
      currency = 'EUR';
      language = 'fr';
      break;
    case 'KR': //Korea
      currency = 'HKD';
      language = 'ko';
      break;
    case 'TH': //Thailand
      currency = 'HKD';
      language = 'th';
      break;
    case 'TW':
    case 'MO':
    case 'HK':
    default:
      currency = 'HKD';
      language = 'zh_HK';
      break;
  }
  return {
    currency,
    language,
  };
}

export function encrypt(data) {
  const s = _.isObject(data) ? JSON.stringify(data) : data;
  return xxtea.encryptToString(s, appConfig.SECRET_KEY);
}

export function decrypt(data) {
  const decrypted = xxtea.decryptToString(data, appConfig.SECRET_KEY);
  try {
    return JSON.parse(decrypted);
  } catch (e) {
    return decrypted;
  }
}

export function getLoadingInstance(options = {}) {
  return Loading.service(_.merge({
    text: 'Loading',
    lock: true,
  }, options));
}
